<template>
    <div class="service_provider_settled_in_list">
        <div class="tit">
            <span>服务商认证信息</span>
        </div>
        <!-- content -->
        <div class="body_content">
            <div class="" v-if="!tableData.length">
                <el-button type="primary" @click="go('service_provider_settled_in_from')">去认证</el-button>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;入驻成为园区服务商后，才能开设店铺、上架商品，为园区的企业提供服务</span>
            </div>
            <div v-else>
                <!-- 1有认证过显示列表 -->
                <div class="table_tit">
                    <div>
                        <el-button type="primary" @click="go('service_provider_settled_in_from');">新增入驻</el-button>
                    </div>
<!--                    <div class="search">-->
<!--                        <el-input-->
<!--                            class="el-input-180 mr10"-->
<!--                            v-model="searchObj.name"-->
<!--                            placeholder="请输入内容"-->
<!--                            @keyup.native.enter="search"-->
<!--                        ></el-input>-->
<!--                        <el-select class="el-select-120" v-model="searchObj.status" placeholder="请选择" @change="search">-->
<!--                            <el-option-->
<!--                                v-for="item in status"-->
<!--                                :key="item.code"-->
<!--                                :label="item.name"-->
<!--                                :value="item.code">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </div>-->
                </div>
                <el-table :data="tableData" border style="width: 100%" class="mt20">
                    <el-table-column fixed prop="extend3" label="单位名称"></el-table-column>
                    <el-table-column prop="incubator_name" label="申请园区"></el-table-column>
                    <el-table-column prop="bs_register_money" label="注册资金(万元)" width="120"></el-table-column>
                    <el-table-column prop="extend2" label="联系人姓名" width="120"></el-table-column>
                    <el-table-column prop="status_name" label="认证状态" width="120">
<!--                        <template slot-scope="scope">-->
<!--                            <div v-if="scope.row.status==='IdentityCertifieStatusNotSubmitted'">未提交</div>-->
<!--                            <div v-else-if="scope.row.status==='IdentityCertifieStatusSubmitted'">已提交</div>-->
<!--                            <div v-else-if="scope.row.status==='IdentityCertifieStatusWithdraw'">已撤回</div>-->
<!--                            <div v-else-if="scope.row.status==='IdentityCertifieStatusInReview'">已核对</div>-->
<!--                            <div v-else-if="scope.row.status==='IdentityCertifieStatussuccess'">通过</div>-->
<!--                            <div v-else-if="scope.row.status==='IdentityCertifieStatusFailed'">不通过</div>-->
<!--                            <div v-else-if="scope.row.status==='IdentityCertifieStatusReturned'">已退回</div>-->
<!--                        </template>-->
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <!--未提交 -->
                            <div class="center" v-if="scope.row.status==='IdentityCertifieStatusNotSubmitted'">
                                <div>
                                    <div class="blue_btn" @click="backEdit(scope.row)">返回修改</div>
                                </div>
                            </div>
                            <!-- 撤回 -->
                            <div class="center" v-if="scope.row.status==='IdentityCertifieStatusWithdraw'">
                                <div>
                                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                                </div>
                                <div>
                                    <div class="blue_btn" @click="backEdit(scope.row)">返回修改</div>
                                </div>
                            </div>
                            <!-- 已提交 -->
                            <div class="center" v-else-if="scope.row.status==='IdentityCertifieStatusSubmitted'">
                                <div>
                                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                                </div>
                                <div>
                                    <div class="blue_btn" @click="suredemandApproval(scope.row)">撤回认证</div>
                                </div>
                            </div>
                            <!-- 已通过 已核对-->
                            <div class="center" v-else-if="scope.row.status==='IdentityCertifieStatussuccess' || scope.row.status==='IdentityCertifieStatusInReview'">
                                <div>
                                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                                </div>
                            </div>
                            <!--不通过 || 未通过   -->
                            <div class="center" v-else-if="scope.row.status==='IdentityCertifieStatusFailed'">
                                <div>
                                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                                </div>
                                <div>
                                    <div class="blue_btn" @click="viewOpinions(scope.row)">查看意见</div>
                                </div>
                            </div>
                            <!-- 已退回 -->
                            <div class="center" v-else-if="scope.row.status==='IdentityCertifieStatusReturned'">
                                <div>
                                    <div class="blue_btn" @click="viewOpinions(scope.row)">查看意见</div>
                                </div>
                                <div>
                                    <div class="blue_btn" @click="detail(scope.row)">查看详情</div>
                                </div>
                                <div>
                                    <div class="blue_btn" @click="backEdit(scope.row)">返回修改</div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
                </div>

                <!-- 意见 -->
                <el-dialog title="查看意见" :visible.sync="dialogVisible" width="600px" center>
                    <span v-if="row && row.examine_remark" v-cloak>{{row.examine_remark}}</span>
                    <span v-else>暂无</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                      </span>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import myPage from "@/components/myPage/myPage";
    export default {
        components: {
            myPage
        },
        data(){
            return{
                tableData: [],
                layerpageinfo: {
                    //分页
                    pageNo: 0,
                    total: 0,
                    pageSize: 10,
                },
                searchObj:{
                  name: '',
                  status: ''
                },
                dialogVisible: false,
                row: null,
                status:[
                    {name: '全部状态', code: ''},
                    {name: '未提交', code: 'IdentityCertifieStatusNotSubmitted'},
                    {name: '已提交', code: 'IdentityCertifieStatusSubmitted'},
                    {name: '已撤回', code: 'IdentityCertifieStatusWithdraw'},
                    {name: '初审通过', code: 'IdentityCertifieStatusInReview'},
                    {name: '复审通过', code: 'IdentityCertifieStatussuccess'},
                    {name: '退回修改', code: 'IdentityCertifieStatusReturned'},
                    {name: '不通过', code: 'IdentityCertifieStatusFailed'},
                ]
            }
        },
        computed:{
          info(){
              return this.$store.state.info
          }
        },
        created() {
            if (this.info) {
                this.getEnterprises();
            } else {
                this.needInfo("getEnterprises");
            }
        },
        methods: {
            // 下载入驻协议
            downloadfile(row) {},
            /* 监测Props */
            needInfo(name) {
                let watchAch = this.$watch("info", (val, oldVal) => {
                    if (val) {
                        this[name]();
                        watchAch(); //取消监听
                    }
                });
            },
            search(){
              this.layerpageinfo.pageNo = 0;
              this.getEnterprises();
            },
            /** 查询入驻园区*/
            getEnterprises() {
                let params = Object.assign({}, this.layerpageinfo, this.searchObj, {
                    type: "StarryExtendTypeBService",
                    user_id: this.info.id
                });
                // this.api.getEnterprises(params).then(res => {
                //     if (res.error["err_code"] !== 0) return;
                //     let list = res.obj.list || [];
                //     this.tableData = list;
                //     this.layerpageinfo.total = res.obj.totalSize;
                // });
                this.api.getExtends(params).then(res => {
                    if (res.error["err_code"] !== 0) return;
                    let list = res.obj.list || [];
                    this.tableData = list;
                    this.layerpageinfo.total = res.obj.totalSize;
                });
            },
            /*页面跳转*/

            go(name) {
                this.$router.push({
                    name: name
                });
                sessionStorage.removeItem("serviceProviderSettledId"); //清空企业认证id
            },

            /*改变分页*/

            changePage(pageNo) {
                this.layerpageinfo.pageNo = pageNo;
                this.getEnterprises();
            },
            /*返回修改 编辑*/
            backEdit(item) {
                this.$router.push({
                    name: "service_provider_settled_in_from",
                    query: {
                        id: item.id
                    }
                });
            },
            /*查看详情*/

            detail(item) {
                this.$router.push({
                    name: "service_provider_settled_in_detail",
                    query: {
                        id: item.id
                    }
                });
            },
            /* 取消机构认证弹窗*/
            suredemandApproval(row) {
                this.$confirm("确定取消入驻申请?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.demandApproval(row);
                    })
                    .catch(() => {});
            },
            /* 取消机构认证 */
            demandApproval(row) {
                this.api
                    .saveOrSubmitNBService({
                        id: row.id,
                        operation: "IdentityCertifieStatusWithdraw",
                        examine_remark: "撤回",
                        incubator: row.incubator
                    })
                    .then(res => {
                        if (res.error.err_code !== 0) return;
                        this.$message({
                            type: "success",
                            message: "取消成功!"
                        });
                        this.getEnterprises(); //列表
                    });
            },
            /* 查看意见 */
            viewOpinions(row) {
                this.dialogVisible = true;
                this.row = row;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .blue_btn {
        color: $font-blue;
        cursor: pointer;
    }
    .service_provider_settled_in_list {
        .table_tit {
            display: flex;
            justify-content: space-between;
            .table_tit_text {
                margin-left: 20px;
                line-height: 20px;
            }
            .el-input-180{
                width: 180px;
            }
            .el-select-120{
                width: 100px;
            }
            .mr10{
                margin-right: 10px;
            }
        }
    }
</style>
